// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__DjQwl","name":"Header_name__1FQqQ","birthday":"Header_birthday__2cnN-","skeleton":"Header_skeleton__1Bm5M"};